import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const findController = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}) => {
  const controllers = await editorSdkProxy.controllers.listControllers({
    pageRef,
  })

  return { controllerRef: controllers[0].controllerRef }
}
